// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import avatarSliceReducer from './slices/avatarSlice';
import bankAccountSliceReducer from './slices/bankAccountSlice';
import itemForEditSliceReducer from './slices/itemForEditSlice';
import companySliceReducer from './slices/companySlice';
import contactSliceReducer from './slices/contactSlice';
import contractTermSliceReducer from './slices/contractTermSlice';
import currencySliceReducer from './slices/currencySlice';
import exRatesSliceReducer from './slices/exRatesSlice';
import formTouchedReducer from './slices/formTouchedSlice';
import itemEmailSliceReducer from './slices/itemEmailSlice';
import itemForItemInvSliceReducer from './slices/itemForItemInvSlice';
import itemForEditBasicSliceReducer from './slices/itemForEditBasicSlice';
import loadingStatusSliceReducer from './slices/loadingStatusSlice';
import noteTermSliceReducer from './slices/noteTermSlice';
import notificationSliceReducer from './slices/notificationSlice';
import personSliceReducer from './slices/personSlice';
import popupSliceReducer from './slices/popupSlice';
import popupBasicSliceReducer from './slices/popupBasicSlice';
import popupNotificationSliceReducer from './slices/popupNotificationSlice';
import popupOpenSliceReducer from './slices/popupOpenSlice';
import popupSimpleSliceReducer from './slices/popupSimpleSlice';
import popupTopSliceReducer from './slices/popupTopSlice';
import quoteSliceReducer from './slices/quoteSlice';
import searchInvSliceReducer from './slices/searchInvSlice';
import searchQuoteSliceReducer from './slices/searchQuoteSlice';
import statusSliceReducer from './slices/statusSlice';
import authReducer from './slices/authApiSlice';
import { api } from './services/api';

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,

    authSlice: authReducer,

    avatarSlice: avatarSliceReducer,
    bankAccountSlice: bankAccountSliceReducer,
    companySlice: companySliceReducer,
    contactSlice: contactSliceReducer,
    contractTermSlice: contractTermSliceReducer,
    currencySlice: currencySliceReducer,
    formTouchedSlice: formTouchedReducer,
    exRatesSlice: exRatesSliceReducer,
    itemEmailSlice: itemEmailSliceReducer,
    itemForEditSlice: itemForEditSliceReducer,
    itemForEditBasicSlice: itemForEditBasicSliceReducer,
    itemForItemInvSlice: itemForItemInvSliceReducer,
    loadingStatusSlice: loadingStatusSliceReducer,
    noteTermSlice: noteTermSliceReducer,
    notificationSlice: notificationSliceReducer,
    personSlice: personSliceReducer,
    popupBasicSlice: popupBasicSliceReducer,
    popupOpenSlice: popupOpenSliceReducer,
    popupSimpleSlice: popupSimpleSliceReducer,
    popupTopSlice: popupTopSliceReducer,
    popupNotificationSlice: popupNotificationSliceReducer,
    popupSlice: popupSliceReducer,
    quoteSlice: quoteSliceReducer,
    searchInvSlice: searchInvSliceReducer,
    searchQuoteSlice: searchQuoteSliceReducer,
    statusSlice: statusSliceReducer,
  },

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);

export default store;
